import { Pipe, PipeTransform } from '@angular/core';
import {User} from '@app/shared';

@Pipe({
  name: 'mentionTransform',
  standalone: false
})
export class MentionTransformPipe implements PipeTransform {

  transform(text: string, users: User[]): string {
    if (!text || !users) return text;

    // Capturar menciones del tipo @id (sin el nombre)
    return text.replace(/@(\d+)/g, (match, id) => {
      const user = users.find(u => u.id.toString() === id);
      return user ? `@${user.partner!.name}${user.partner.surName}` : match;
    });
  }

}
